<template>
  <div>
    <ui-tabs fullwidth>
      <!-- Secciones -->
      <ui-tab key="secciones" title="Secciones">
        <secciones-tabla
          :data="data"
          :listaSecciones="listaSecciones"
          :listaModulos="lista_modulos"
        />
      </ui-tab>

      <!-- Sub Secciones -->
      <ui-tab key="subsecciones" title="Sub Secciones">
        <sub-secciones-tabla
          v-if="listaSecciones.length > 0"
          :listaSecciones="listaSecciones"
          :listaModulos="lista_modulos"
        />
      </ui-tab>
    </ui-tabs>
  </div>
</template>

<script>
// Components
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";
import SeccionesTabla from "./secciones/seccionesTabla";

// Lazy Load

export default {
  components: {
    SeccionesTabla,
    UiTabs,
    UiTab,
    // Lazy Load
    subSeccionesTabla: () =>
      import(
        /* webpackPrefetch: subSeccionesTabla */ "./secciones/subSeccionesTabla"
      ),
  },
  props: ["data", "lista_modulos"],
  data() {
    return {
      listaSecciones: [],
      dataTableAux: [],
    };
  },
  methods: {
    obtenerListaSecciones() {
      this.data.map((item) => {
        this.listaSecciones.push({
          id: item.data_complementaria.id_seccion,
          name: item.data[0],
        });
      });
    },
  },
  watch: {
    data: function (_new) {
      _new && this.obtenerListaSecciones();
      if (_new) {
        this.dataTableAux = _new;
      }
    },
  },
};
</script>

<style></style>
